<template lang="pug">
  div
    router-view(:key="$route.name").router
</template>
<script>
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";

export default {
  created() {
    esMessages.es["dxList-selectAll"] = "Todo";
    loadMessages(esMessages);
    locale("es-PE");
  }
};
</script>
<style>
.app {
  height: 100vh;
}

.router {
  height: 100vh;
}

.text-align-center {
  text-align: center;
}

.contenedor-grilla {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  align-content: space-around;
  width: 100%;
}

.item-grilla {
  background-color: #f5f5f5;
  text-align: center;
  margin: 2px;
}

.dx-item.dx-tab.dx-tab-selected {
  background-color: lightgray !important;
  font-weight: 600;
}

.dx-item.dx-tab {
  background-color: #f5f5f5 !important;
  font-weight: 500;
  /* border: 1px solid; */
}

.dx-item.dx-tab .dx-tab-text {
  font-size: 1.05em !important;
}

label {
  line-height: 2em;
}
</style>
